
<!-- id "items_filterpanel_control" must be unique and is used in component file to closet the filter menu-->
<div id="requests_filterpanel_control" [ngClass]="{'zsd-cust-filter-filtermenu-lg':windowSize >= 992}" class="zsd-cust-filter-filtermenu">

    <button class="btn zsd-cust-filter-button zsd-cust-filter-filtermenu-closebtn d-block d-xl-none d-lg-none" (click)="closeFilter()">
     <span class="fa fa-arrow-left fa-lg"></span>
 </button>
    <div class="card" id="zsd_cust_filter_panel">
        <div class="card-body pb-0">
            <!-- Adding Filter as title at the top of the Filter-->
            <div class="card-title" id="zsd_cust_filter_text">
                <em class="fa fa-filter custom-filter"></em>{{ 'CommonStrings.filter' | translate }}
            </div>
        </div>
        <div class="card-body pb-0">
            <div id="zsd_request_filter_my_actions" class="mt-0">
                <div class="form-check">
                    <input type="checkbox" class="form-check-input"  [(ngModel)]="openOnlyChecked"  id="open_requests_checkbox">
                    <label class="form-check-label" for="open_requests_checkbox" >{{ 'RequestsFilter.openRequests' | translate }}</label>
                </div>
            </div>
        </div>
        <div class="card-body zsd-cust-filter-bottom-line">
            <div class="form-check">
                <input type="checkbox" class="form-check-input"  [(ngModel)]="myApprovalChecked"  id="my_approval_requests_checkbox">
                <label class="form-check-label" for="my_approval_requests_checkbox" id="my_approval_requests_label">
                        <img src="img/awaitingMyApproval.png"/>
                        {{ 'RequestsFilter.awaitingMyApproval' | translate }}</label>
            </div>
            <div class="form-check">
                <input type="checkbox" class="form-check-input"   [(ngModel)]="myNeedInfoChecked"  id="my_approval_needInfo_checkbox">
                <label class="form-check-label" for="my_approval_needInfo_checkbox"  id="my_approval_needInfo_label">
                        <span class="fas fa-allergies" id="my_approval_needInfo_image"></span>
                        {{ 'RequestsFilter.awaitingMyInputs' | translate }} </label>
            </div>
        </div>

             
 
     <!-- Category -->
     <div class="card-body zsd-cust-filter-bottom-line">
             <div class="card-title" id="zsd_cust_filter_category" data-toggle="collapse" data-target="#zsd_items_category_target" [class.collapsed]="!categoryChecked">
                 {{ 'CommonStrings.itemCategoryHeader' | translate }}
             </div>
             <div id="zsd_items_category_target" [className]="categoryChecked ? 'collapse show' : 'collapse' ">
             <div class="search">
                 <input type="text" class="form-control" type="search" id="zsd_cust_filter_placeholder_search" placeholder="{{ 'CommonStrings.search' | translate}}" [(ngModel)]="searchCategory">
             </div>
 
             <div id="zsd_cust_filter_category_list">
                 <div class="form-check" *ngFor="let category of categoryResults | searchFilterPipe:'categoryName':searchCategory">
                     <label class="form-check-label" for="{{category.categoryName}}">
                         <input type="checkbox" class="form-check-input" value="category" id="{{category.categoryName}}" [(ngModel)]="category.checked">{{category.categoryName}}
                     </label>
                 </div>
             </div>
             </div>
         </div>
         
 
 
             <!-- Item Types -->
         <div class="card-body zsd-cust-filter-bottom-line">
                 <div class="card-title" id="zsd_cust_filter_item_types" data-toggle="collapse" data-target="#zsd_item_types_target" [class.collapsed]="!itemTypeChecked">
                     {{ 'CommonStrings.itemTypesHeader' | translate }}
                 </div>
                 <div id="zsd_item_types_target" [className]="itemTypeChecked ? 'collpase show' : 'collapse'">
                 <div class="search">
                     <input type="text" class="form-control" type="search" id="zsd_cust_filter_placeholder_search" placeholder="{{ 'CommonStrings.search' | translate}}" [(ngModel)]="searchItemType">
                 </div>
                 <div id="zsd_cust_filter_item_types_list">
                     <div class="form-check" *ngFor="let itemType of itemTypesResults | searchFilterPipe: 'itemTypeName':searchItemType">
                         <label class="form-check-label" for="{{itemType.itemTypeName}}">
                             <input type="checkbox" class="form-check-input" value="itemType" id="{{itemType.itemTypeName}}" [(ngModel)]="itemType.checked">{{itemType.itemTypeName}}
                         </label>
                     </div>
                 </div>
                 </div>
     
             </div>

             <!-- Status types -->
             <div class="card-body zsd-cust-filter-bottom-line">
                    <div class="card-title" id="zsd_cust_filter_status_types" data-toggle="collapse" data-target="#zsd_status_types_target" [class.collapsed]="!statusTypeChecked">
                        {{ 'CommonStrings.statusTypesHeader' | translate }}
                    </div>
                    <div id="zsd_status_types_target" [className]="statusTypeChecked ? 'collpase show' : 'collapse'">
                    <div class="search">
                        <input type="text" class="form-control" type="search" id="zsd_cust_filter_placeholder_search" placeholder="{{ 'CommonStrings.search' | translate}}" [(ngModel)]="searchStatusType">
                    </div>
                    <div id="zsd_cust_filter_status_types_list">
                        <div class="form-check" *ngFor="let statusType of statusTypeResults | searchFilterPipe: 'statusName':searchStatusType">
                            <label class="form-check-label" for="{{statusType.statusName}}">
                                <input type="checkbox" class="form-check-input" value="statusType" id="{{statusType.statusName}}" [(ngModel)]="statusType.checked">{{statusType.statusName}}
                            </label>
                        </div>
                    </div>
                    </div>
        
                </div> 
     
             <div class="form-group text-center" id="zsd_cust_filter_button_id">
                 <button type="submit" class="btn zsd-cust-filter-button" id="zsd_cust_filter_button_apply" (click)="applyFilter()">{{ 'CommonStrings.applyButton' | translate }}</button>
                 <button type="button" class="btn zsd-cust-filter-button" id="zsd_cust_filter_button_clear" (click)="clearFilter()">{{ 'CommonStrings.clearButton' | translate }}</button>
             </div>
     
 
    </div>
 </div>